import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import type {CanvasControls, ReportPage} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/reportsWorkspaceCapability/domain/ReportJson";
import {z as zod} from "zod";
import {iso8601DateTimeZodValidator, uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {canvasControlsZodValidator, reportPageZodValidator} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/reportsWorkspaceCapability/domain/ReportJsonValidators";

export enum ReportStatus {
    active = "d49a5843-8ce2-4188-b18d-aa980b662a05",
    deleted = "19c91082-7351-479f-a00f-3ed77f69247a",
};

export type Report = {
    canvasControls: CanvasControls;
    createdAt: Iso8601DateTime;
    createdBy: Uuid;
    displayName: string;
    id: Uuid;
    isPinned: boolean;
    pages: Array<ReportPage> | null;
    requiredDatasetIds: Array<Uuid>;
    sourceReportTemplateId: Uuid | null;
    status: ReportStatus;
    updatedAt: Iso8601DateTime;
    updatedBy: Uuid;
    workspaceId: Uuid;
};

export type ReportMetadata = Omit<Report, "canvasControls" | "pages"> & {
    isFavorite: boolean;
};

export const reportZodValidator: zod.ZodType<Report> = zod.object({
    canvasControls: canvasControlsZodValidator,
    createdAt: iso8601DateTimeZodValidator,
    createdBy: uuidZodValidator,
    displayName: zod.string(),
    id: uuidZodValidator,
    isPinned: zod.boolean(),
    pages: zod.array(reportPageZodValidator).nullable(),
    requiredDatasetIds: zod.array(uuidZodValidator),
    sourceReportTemplateId: uuidZodValidator.nullable(),
    status: zod.enum(ReportStatus),
    updatedAt: iso8601DateTimeZodValidator,
    updatedBy: uuidZodValidator,
    workspaceId: uuidZodValidator,
});

export const reportMetadataZodValidator: zod.ZodType<ReportMetadata> = zod.object({
    createdAt: iso8601DateTimeZodValidator,
    createdBy: uuidZodValidator,
    displayName: zod.string(),
    id: uuidZodValidator,
    isFavorite: zod.boolean(),
    isPinned: zod.boolean(),
    requiredDatasetIds: zod.array(uuidZodValidator),
    sourceReportTemplateId: uuidZodValidator.nullable(),
    status: zod.enum(ReportStatus),
    updatedAt: iso8601DateTimeZodValidator,
    updatedBy: uuidZodValidator,
    workspaceId: uuidZodValidator,
});
